import { MobileWarning } from '@/common/components/MobileWarning'
import * as Sentry from '@sentry/react'
import { isMobile } from 'react-device-detect'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import PrivateRoute from './common/components/PrivateRoute'
import useLoadingPage from './common/hooks/useLoadingPage'
import Layout from './common/Layout'
import { privateRoutes, publicRoutes } from './routes'
import InternalRouter from './common/components/InternalRouter'

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

function App() {
  useLoadingPage()

  if (isMobile) return <MobileWarning />

  return (
    <div>
      <BrowserRouter>
        <InternalRouter>
          <SentryRoutes>
            {publicRoutes.map((route) => (
              <Route path={route.path} Component={route.comp} key={route.path} />
            ))}
            <Route element={<Layout />}>
              <Route element={<PrivateRoute />}>
                {privateRoutes.map((route) => (
                  <Route path={route.path} Component={route.comp} key={route.path} />
                ))}
              </Route>
            </Route>
          </SentryRoutes>
        </InternalRouter>
      </BrowserRouter>
    </div>
  )
}

export default App
